import { getDataProps } from './dataProps';

export const sellerDetailView = (adId: number) => {
    const { urls } = getDataProps();
    return `${urls.internal.statusSell}/${adId}`;
};

export const buyerDetailView = (transactionId: string) => {
    const { urls } = getDataProps();
    return `${urls.internal.statusBuy}/${transactionId}`;
};
